import { combineReducers } from 'redux'
import { rfpData, otherRFPs } from './rfp'
import questions from './questions'
import contacts from './contacts'
import snackbar from './snackbar'
import { loadingBarReducer } from 'react-redux-loading'

export default combineReducers({
	rfpData,
	questions,
	otherRFPs,
	contacts,
	loadingBar: loadingBarReducer,
	snackbar
})


// WEBPACK FOOTER //
// ./src/reducers/index.js